import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loading } from './Loading';


export const PageNotFound = () => {
    const navigate = useNavigate();

    useEffect(() => {
            navigate('/Home/404');
    }, []);


    return (
                <Loading showContent={true} includeHero={true} key='permissionsPage' />
    );
};